import { render } from "./WithTypes.vue?vue&type=template&id=e3584bb0"
import script from "./WithTypes.vue?vue&type=script&lang=js"
export * from "./WithTypes.vue?vue&type=script&lang=js"
script.render = render

export default script